module.exports = __webpack_public_path__ + "static/media/humanPic1.cb21f1d4.png";